

import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { Document } from '@roc/feature-types';
import { makeStyles } from '@material-ui/core/styles';
import { InsuranceInformationReviewBaseStore } from '../stores';
import { InsuranceInformationReview } from './insuranceInformationReview';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type InsuranceInformationReviewDialogProps = {
  open?: boolean;
  onClose?: () => void;
  document: Document;
  store: InsuranceInformationReviewBaseStore;
  loanId: string;
};

const useStyles = makeStyles(theme => ({
  dialog: {
    '& .dialog-content-box': {
      margin: theme.spacing(0),
    },
    '& .MuiDialogContent-root': {
      padding: '20px 24px 0 24px',
    },
    '& .MuiDialogTitle-root': {
      paddingBottom: 0
    }
  }
}));

export const InsuranceInformationReviewDialog = observer(
  (props: InsuranceInformationReviewDialogProps) => {
    const { open, onClose, store, loanId, document } = props;
    const taskId = document?.taskId;
    const classes = useStyles();

    const getContent = () => {
      return (
        <InsuranceInformationReview
          store={store}
          loanId={loanId}
          onClose={onClose}
        />
      );
    }
    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            className={classes.dialog}
            open={open}
            title='Insurance Information Review'
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={getContent()}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            className={classes.dialog}
            open={open}
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={getContent()}
          />
        )}
      </>
    );
  }
);
